module.exports = __webpack_public_path__ + "static/media/Bagnard-Regular.714bd54b.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Bagnard-Regular.otf
// module id = 2372
// module chunks = 50